export default "__VITE_ASSET__CrSxo3UU__"